import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const Home = () => {
  return (
    <div className='home'>
      <div className='hero-section'>
        <div className='hero-content'>
          <h1 className='hero-title'>Money Minded Apes</h1>
          <h2 className='hero-subtitle'>NFT Collection Rankings</h2>
          <p className='hero-description'>
            Explore the rarity rankings and sales history of our exclusive NFT collections. Discover
            the most valuable and rare Money Minded Apes across our different collections.
          </p>
        </div>
      </div>
      <div className='collections-section'>
        <div className='container'>
          <h2 className='section-title'>Our Collections</h2>
          <div className='collections-grid'>
            <div className='collection-card'>
              <div className='card-header'>
                <h3>OG Money Minded Apes</h3>
              </div>
              <div className='card-content'>
                <p>
                  The original Money Minded Apes Drops 1 through 5 collection with detailed traits
                  including backgrounds, fur, accessories, and more unique characteristics.
                </p>
                <div className='card-stats'>
                  <span className='stat'>1,730 Items</span>
                  <span className='stat'>Original Collection</span>
                </div>
              </div>
              <div className='card-footer'>
                <Link to='/og-apes' className='explore-btn'>
                  Explore Ranks
                </Link>
                <Link to='https://swiftmint.net/collections/drops-1-5' className='explore-btn'>
                  Buy on Swiftmint
                </Link>
              </div>
            </div>
            <div className='collection-card'>
              <div className='card-header'>
                <h3>Private Jet Apes</h3>
              </div>
              <div className='card-content'>
                <p>
                  The Private Jet Apes collection featuring unique Private Jet designs with various
                  custom traits and collection affiliations.
                </p>
                <div className='card-stats'>
                  <span className='stat'>580 Items</span>
                  <span className='stat'>Mile High Style</span>
                </div>
              </div>
              <div className='card-footer'>
                <Link to='/private-jet-apes' className='explore-btn'>
                  Explore Ranks
                </Link>
                <Link to='https://swiftmint.net/collections/private-jet-ape' className='explore-btn'>
                  Buy on Swiftmint
                </Link>
              </div>
            </div>
            <div className='collection-card'>
              <div className='card-header'>
                <h3>X War Meta Apes</h3>
              </div>
              <div className='card-content'>
                <p>
                  The original X War Meta Apes collection with detailed traits including
                  backgrounds, fur, weapons, accessories, and more unique characteristics.
                </p>
                <div className='card-stats'>
                  <span className='stat'>121 Items</span>
                  <span className='stat'>Veterans of the Trenches</span>
                </div>
              </div>
              <div className='card-footer'>
                <Link to='/xwar-apes' className='explore-btn'>
                  Explore Ranks
                </Link>
                <Link to='https://swiftmint.net/collections/x-war' className='explore-btn'>
                  Buy on Swiftmint
                </Link>
              </div>
            </div>
            <div className='collection-card'>
              <div className='card-header'>
                <h3>Top G Apes</h3>
              </div>
              <div className='card-content'>
                <p>
                  The Top G Apes collection with detailed traits including backgrounds, fur,
                  accessories, and more unique characteristics.
                </p>
                <div className='card-stats'>
                  <span className='stat'>4,300 Items</span>
                  <span className='stat'>Top Gs</span>
                </div>
              </div>
              <div className='card-footer'>
                <Link to='/top-g-apes' className='explore-btn'>
                  Explore Ranks
                </Link>
                <Link
                  to='https://swiftmint.net/collections/top-g-apes'
                  className='explore-btn'
                >
                  Buy on Swiftmint
                </Link>
              </div>
            </div>
            <div className='collection-card'>
              <div className='card-header'>
                <h3>Money Minded Mutants</h3>
              </div>
              <div className='card-content'>
                <p>
                  The original Money Minded Mutants collection with detailed traits including
                  backgrounds, fur, accessories, and more unique characteristics.
                </p>
                <div className='card-stats'>
                  <span className='stat'>4,300 Items</span>
                  <span className='stat'>Mutants</span>
                </div>
              </div>
              <div className='card-footer'>
                <Link to='/mutants' className='explore-btn'>
                  Explore Ranks
                </Link>
                <Link to='https://swiftmint.net/collections/money-minded-mutants' className='explore-btn'>
                  Buy on Swiftmint
                </Link>
              </div>
            </div>
            <div className='collection-card'>
              <div className='card-header'>
                <h3>Money Minded Pixel Apes</h3>
              </div>
              <div className='card-content'>
                <p>
                  The original Money Minded Pixel Apes collection with detailed traits including
                  backgrounds, fur, accessories, and more unique characteristics.
                </p>
                <div className='card-stats'>
                  <span className='stat'>11,049 Items</span>
                  <span className='stat'>Pixel Apes</span>
                </div>
              </div>
              <div className='card-footer'>
                <Link to='/pixel-apes' className='explore-btn'>
                  Explore Ranks
                </Link>
                <Link to='https://swiftmint.net/collections/mma-pixel-apes' className='explore-btn'>
                  Buy on Swiftmint
                </Link>
              </div>
            </div>
            <div className='collection-card'>
              <div className='card-header'>
                <h3>Money Minded Mula Trees</h3>
              </div>
              <div className='card-content'>
                <p>
                  The original Money Minded Mula Trees collection with detailed traits including
                  backgrounds, fur, accessories, and more unique characteristics.
                </p>
                <div className='card-stats'>
                  <span className='stat'>333 Items</span>
                  <span className='stat'>Mula Trees</span>
                </div>
              </div>
              <div className='card-footer'>
                <Link to='/mula-trees' className='explore-btn'>
                  Explore Ranks
                </Link>
                <Link
                  to='https://swiftmint.net/collections/rMoNEYrXBU8KGp86BwJ5hMZff4ovKag8Fr-1100540108'
                  className='explore-btn'
                >
                  Buy on Swiftmint
                </Link>
              </div>
            </div>
            <div className='collection-card'>
              <div className='card-header'>
                <h3>Money Minded Ladies</h3>
              </div>
              <div className='card-content'>
                <p>
                  The original Money Minded Ladies collection with detailed traits including
                  backgrounds, fur, accessories, and more unique characteristics.
                </p>
                <div className='card-stats'>
                  <span className='stat'>1,388 Items</span>
                  <span className='stat'>Ladies</span>
                </div>
              </div>
              <div className='card-footer'>
                <Link to='/ladies' className='explore-btn'>
                  Explore Ranks
                </Link>
                <Link to='https://swiftmint.net/collections/money-minded-ladies' className='explore-btn'>
                  Buy on Swiftmint
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='features-section'>
        <div className='container'>
          <h2 className='section-title'>Features</h2>

          <div className='features-grid'>
            <div className='feature-item'>
              <div className='feature-icon'>📊</div>
              <h3>Rarity Rankings</h3>
              <p>Comprehensive rarity scoring with multiple calculation methods</p>
            </div>

            <div className='feature-item'>
              <div className='feature-icon'>💰</div>
              <h3>Sales History</h3>
              <p>Track historical and current sales data for informed decisions</p>
            </div>

            <div className='feature-item'>
              <div className='feature-icon'>🔍</div>
              <h3>Advanced Filtering</h3>
              <p>Filter by traits, rarity scores, and collection attributes</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
